<template>
  <div>
    <!-- 遮罩层 -->
    <transition name="fade">
      <div
        v-if="visible"
        class="dialog-overlay"
        @click="handleOverlayClick"
      ></div>
    </transition>

    <!-- 弹窗 -->
    <transition name="pop">
      <div v-if="visible" class="dialog-container">
        <div class="dialog-content" @click.stop>
          <!-- 关闭按钮 -->
          <button class="close-btn" @click="close">
            <img src="../../../assets/shop/pop/close.png" alt="" />
          </button>
          <!-- 规则内容 -->
          <div class="dialog-body">
            <p>
              1. Cách Thức Tham Gia: Người chơi có thể dùng 100 hoặc 5000 điểm
              để tham gia rút thưởng, mỗi ván sẽ quay 3 lần, phần thưởng được
              tính theo 3 biểu tượng cuối cùng.
            </p>
            <p>
              2. Biểu Tượng Vòng Quay: Bao gồm các số từ 1–6, 1 loại trái cây,
              Xu Vàng và Kim Cương, Sau khi quay, vòng quay sẽ dừng lại ở 3 biểu
              tượng ngẫu nhiên.
            </p>
            <p>3. Quy tắc trúng thưởng:</p>
            <p>Ván 100 điểm</p>
            <p>- Không trúng: Không hoàn lại</p>
            <p>- 1 Xu Vàng + 2 biểu tượng khác: Hoàn 50% điểm</p>
            <p>- 1 Kim Cương + 2 biểu tượng khác: Hoàn 100% điểm</p>
            <p>- 3 số giống nhau: Thưởng gấp 2</p>
            <p>- 3 trái cây giống nhau: Thưởng gấp 3</p>
            <p>- 2 Xu Vàng + 1 biểu tượng bất kỳ: Thưởng gấp 4</p>
            <p>- 3 Xu Vàng: Thưởng gấp 8</p>
            <p>- 3 Kim Cương: Thưởng gấp 50</p>
            <p style="text-align: center">
              <img
                style="width: 70%"
                src="../../../assets/shop/pop/rules_info_100.png"
                alt=""
              />
            </p>
            <p>Ván 5000 điểm</p>
            <p>- Không trúng: Không hoàn lại</p>
            <p>- 1 Xu Vàng + 2 biểu tượng khác: Hoàn 50% điểm</p>
            <p>- 1 Kim Cương + 2 biểu tượng khác: Hoàn 100% điểm</p>
            <p>- 3 số giống nhau: Thưởng gấp 2</p>
            <p>- 3 trái cây giống nhau: Thưởng gấp 4</p>
            <p>- 2 Xu Vàng + 1 biểu tượng bất kỳ: Thưởng gấp 8.</p>
            <p>- 3 Xu Vàng: Thưởng gấp 20</p>
            <p>- 3 Kim Cương: Thưởng gấp 100</p>
            <p style="text-align: center">
              <img
                style="width: 70%"
                src="../../../assets/shop/pop/rules_info_5000.png"
                alt=""
              />
            </p>
            <p>
              4. Phần Thưởng và Giới Hạn: Phần thưởng được gửi ngay lập tức, nếu
              không trúng sẽ không hoàn lại điểm; Mỗi người tối đa có 10 lượt
              tham gia mỗi ngày; số lượt sẽ tự động làm mới vào 0:00 hằng ngày.
            </p>
            <p>
              5. Xử Lý Vi Phạm: Nghiêm cấm sử dụng thủ đoạn gian lận, script
              hoặc các hành vi vi phạm khác để tham gia. Nếu bị phát hiện, sẽ
              hủy tư cách tham gia, thu hồi toàn bộ phần thưởng đã nhận và xử lý
              tài khoản theo quy định của nền tảng.
            </p>
            <p>
              6. Khác: Quyền giải thích cuối cùng thuộc về nền tảng. Nền tảng có
              quyền điều chỉnh thể lệ theo tình hình vận hành và sẽ thông báo
              sau nếu cần.
            </p>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "RulesDialog",
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    /**
     * 打开弹窗
     */
    open() {
      this.visible = true;
    },
    /**
     * 关闭弹窗
     */
    close() {
      this.visible = false;
    },
    /**
     * 处理遮罩层点击 - 可选关闭或不关闭
     */
    handleOverlayClick() {
      // 如果需要点击遮罩层关闭弹窗，取消注释下一行
      // this.close();
    },
  },
};
</script>

<style scoped lang="scss">
// 遮罩层
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

// 弹窗容器
.dialog-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

// 弹窗内容
.dialog-content {
  background-image: url(../../../assets/shop/pop/rules_bg.png);
  background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 20px;
  width: 45vw;
  height: 33vw;
  position: relative;
  padding: 9vw 8vw 7vw 7vw;
  box-sizing: border-box;
}

// 关闭按钮
.close-btn {
  position: absolute;
  top: 1vw;
  right: 0vw;
  width: 4vw;
  height: 5vw;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &:hover {
    transform: scale(1.1);
  }
}

// 标题
.dialog-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

// 内容
.dialog-body {
  font-size: 14px;
  line-height: 1.8;
  color: #666;
  height: 18vw;
  overflow: auto;

  p {
    margin: 10px 0;
  }
}

// 弹出动画
.pop-enter-active {
  animation: popIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.pop-leave-active {
  animation: popOut 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes popIn {
  from {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}

@keyframes popOut {
  from {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  to {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
  }
}

// 淡入淡出动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 1024px) {
  .dialog-content {
    width: 100vw;
    height: 147vw;
    padding: 32vw 22vw 27vw 20vw;
    background-image: url(../../../assets/shop/pop/rules_bg_m.png);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
  }
  .dialog-body {
    height: 90vw;
    width: 58vw;
    position: absolute;
    overflow: auto;
    img {
      width: 95% !important;
    }
  }
  .close-btn {
    top: 132vw;
    left: 50%;
    transform: translateX(-50%);
    width: 10vw;
    height: 10vw;
    &:hover {
      transform: translateX(-50%) scale(1.1);
    }
  }
}
</style>
